import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { h5PageCount } from 'ThreeTerminal_utils';

class TopBanner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        base62Id: PropTypes.string,
    };

    getUrlParams = url => {
        const result = {};
        const urlSearch = (url.split('?') && url.split('?')[1]) || '';

        if (urlSearch) {
            const params = urlSearch.split('&');
            let param = [];

            for (let i = 0, iLen = params.length; i < iLen; i++) {
                param = params[i].split('=');
                if (param.length === 2) {
                    result[param[0]] = decodeURIComponent(param[1]);
                }
            }
        }

        return result;
    };

    clickCount = () => {
        const { base62Id, content } = this.props;

        if (content.type === 'qualityReadingList') {
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'deepread',
                    other: {
                        id: 'deep_qualityReading',
                        tag: 't76',
                        ref: `ucms_${base62Id}`,
                    },
                },
            ]);
        }
        if (content.type === 'hotevent' && content.link && content.link.url) {
            const hotId = this.getUrlParams(content.link.url).eventName;

            h5PageCount([
                {
                    behavior: 'page',
                    type: 'newsgroup',
                    other: {
                        id: `hot_in_${hotId}`,
                        tag: 't76',
                        ref: `ucms_${base62Id}`,
                    },
                },
            ]);
        }
        if (content.type === 'special' && content.link && content.link.url) {
            const specialID = this.getUrlParams(content.link.url).topicid;

            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_${specialID}`,
                        tag: 't76',
                        ref: `ucms_${base62Id}`,
                    },
                },
            ]);
        }

        if (content.type === 'hotspotlist' && content.link && content.link.url) {
            const groupID = this.getUrlParams(content.link.url).groupid;

            h5PageCount([
                {
                    behavior: 'page',
                    type: 'newsgroup',
                    other: {
                        id: `group_${groupID}`,
                        tag: 't76',
                        ref: `ucms_${base62Id}`,
                    },
                },
            ]);
        }
    };

    render() {
        const { content } = this.props;
        let follow = (content.follow && content.follow.toString()) || '';

        if (follow && follow.length > 4) {
            follow = `${(parseInt(follow) / 10000).toFixed(1)}万`;
        }

        return content.type ? (
            <>
                {content.type !== 'qualityReadingList' &&
                    content.thumbnail && (
                        <a
                            href={content.h5url || content?.link?.weburl || content?.link?.url}
                            onClick={this.clickCount}
                            className={styles.topicNoImg}>
                            <div className={styles.topicHead}>
                                <span className={styles.topicMarkText}>{content.source}</span>
                                <span className={styles.topicMarkNum}>{follow ? `${follow}关注` : ''}</span>
                            </div>
                            <div className={styles.topicBox}>
                                <div className={styles.topicPic}>
                                    <img src={content.thumbnail} />
                                </div>
                                <div className={styles.topicText}>
                                    <h2 className={styles.topicTitle}>{content.title}</h2>
                                    <p className={styles.topicPre}>{content.desc}</p>
                                </div>
                            </div>
                        </a>
                    )}
                {content.type !== 'qualityReadingList' &&
                    !content.thumbnail && (
                        <a href={content.h5url} onClick={this.clickCount} className={styles.topicHasImg}>
                            <div className={styles.topicLeft}>
                                <div className={styles.topicHead}>
                                    <span className={styles.topicMarkText}>{content.source}</span>
                                </div>
                                <h2 className={styles.topicTitle}>{content.title}</h2>
                            </div>
                            <div className={styles.topicRight}>
                                <span className={styles.topicMarkNum}>{follow ? `${follow}关注` : ''}</span>
                            </div>
                        </a>
                    )}
                {content.type === 'qualityReadingList' && (
                    <a className={styles.deepRead} onClick={this.clickCount} href={content.h5url}>
                        <img className={styles.deepReadPic} src={content.thumbnail} />
                    </a>
                )}
            </>
        ) : (
            ''
        );
    }
}

export default errorBoundary(TopBanner);
